import Level from './Level.jsx';
import Loading from './Loading.jsx';
import { expectedShelves } from '../shelves.js';
import './eightbit.css';

// The preload's per-shelf counts, filed the way the level files books. Kept
// by identity per outline, because the level rebuilds its whole room whenever
// this changes and a fresh object every render would be every render.
const expected = new WeakMap();
const expectedOf = (outline) => {
  const summary = outline?.summary;
  if (!summary) return null;
  if (!expected.has(summary)) expected.set(summary, expectedShelves(summary.groups));
  return expected.get(summary);
};

// The eight-bit theme: one panel, and it is the whole screen.
//
// The classic theme is two panels the carousel pages between - a shelf, and a
// slideshow of one shelf's books. This one has neither, on purpose. A level
// that scrolls sideways inside a carousel that also scrolls sideways is two
// things fighting over the same gesture, and the thing a person would actually
// be reaching for is the level. So the book detail opens as a sheet over the
// level instead of as a panel beside it, and there is nothing to page to.
export default {
  id: 'eightBit',
  label: '8-bit',

  // What the display shows while the books load - see Loading.jsx.
  Loading,

  // The level can be drawn from the preload alone: it knows how many books
  // each shelf will have, so it stands every bookcase up empty and lets the
  // books fill them as their pages arrive. App.jsx shows the panel as soon as
  // the preload says there is something coming, rather than waiting for the
  // first page under the loading screen.
  drawsAhead: true,

  panels: [
    {
      key: 'level',
      Component: ({ data, settings, active, outline, complete }) => (
        <Level books={data} settings={settings} active={active} expected={complete ? null : expectedOf(outline)} />
      ),
    },
  ],
};
